import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import { BannerDiv, CenteredFormContent } from 'components/Layout/LoginLayout/LoginLayout.Style';
import { CaribTixButton } from 'components/Styled/CaribTixButton.Style'
import RaffleTicketImg from 'assets/images/RAFFLE-TICKET-FRNT.jpg';

//RAFFLE-TICKET-FRNT.jpg
const CaribTixPage: React.FC = () => {
    useEffect(() => {

        (globalThis as any)['SiteID'] = "2599CC79-D592-4D83-93AB-D4AC547B0AFC";
        (globalThis as any)['EID'] = 162031;//0;
        (globalThis as any)['EDID'] = 0;
        (globalThis as any)['Page'] = "SelectEvent";//"ListEvents";
        (globalThis as any)['Width'] = "100%";
        (globalThis as any)['Height'] = "400";
        (globalThis as any)['BgdColor'] = "transparent";
        (globalThis as any)['PluginType'] = "Overlay";
        (globalThis as any)['AutoLoad'] = ""; 
        (globalThis as any)['HasPlugin'] = ""; 

        const caribTixScript = document.createElement('script');
        caribTixScript.id = 'caribtix-scr';
        caribTixScript.src = 'https://connect.vbotickets.com/_assets/js/plugin.js';
        caribTixScript.async = true;

        document.body.appendChild(caribTixScript);
        
        return () => {
            //document.getElementById('caribtix-global')?.remove();
            document.getElementById('caribtix-scr')?.remove();
        };
    }, []); 

    return (
        <CenteredFormContent>
            <BannerDiv className="bannerAlternative">
                <Row style={{ height: '100%' }}>
                    <Col sm={24} className="bannerNav">
                        <div className="pageTitle">
                            <Title>Carib Tix</Title>
                        </div>
                    </Col>
                </Row>
            </BannerDiv>
            <Row align="middle" justify="center">
                <Col xs={20} offset={2}>
                    <a target="_blank" href="https://caribtix.com/jsseraffle"><img src={RaffleTicketImg} style={{ maxWidth: '100%', marginBottom: '40px' }} /></a>
                </Col>
                <Col xs={24}>
                    
                    <CaribTixButton>
                        <div id="MyEvent" style={{ backgroundColor: 'white', width: '100%', margin: 'auto auto', overflow:'auto'}}></div>
                    </CaribTixButton>
                </Col>
            </Row>
        </CenteredFormContent>
    );
};

export default CaribTixPage;
